import { render, staticRenderFns } from "./RightSidePhone.vue?vue&type=template&id=48ce7e09&scoped=true&"
import script from "./RightSidePhone.vue?vue&type=script&lang=js&"
export * from "./RightSidePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce7e09",
  null
  
)

export default component.exports